import CountUp from "react-countup";
import { useSelector } from "react-redux";
import { Card, CardBody } from "reactstrap";
import { createSelector } from "reselect";

const MDAs = () => {
  const selectProperties = createSelector(
    (state: any) => state.LOA,
    (state) => ({
      loaSummary: state.loaSummary,
    })
  );
  const { loaSummary } = useSelector(selectProperties);

  return (
    <Card className="card-animate">
      <CardBody>
        <div className="d-flex justify-content-between">
          <div>
            <p className="fw-medium text-muted mb-0">MDAs</p>
            <h2 className="mt-4 ff-secondary fw-semibold fs-22">
              <span className="counter-value">
                <CountUp
                  start={0}
                  prefix={""}
                  suffix={""}
                  separator={""}
                  end={loaSummary?.numberOfMDAsWithLOAs || 0}
                  decimals={0}
                  duration={2}
                />
              </span>
            </h2>
            {/* <p className="mb-0 text-muted">
        <span className={"badge bg-light mb-0 text-success"}>
          <i className={"align-middle "}></i>{" "}
        </span>{" "}
        vs. previous month
      </p> */}
          </div>
          <div>
            <div className="avatar-sm flex-shrink-0">
              <span
                className={
                  "avatar-title rounded-circle fs-4 bg-warning" +
                  "-subtle text-warning"
                }
              >
                <i className={"bx bx-user-circle"}></i>
              </span>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default MDAs;
